import React, { useState, useEffect } from 'react';
import { Col, Row, Form, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-multi-date-picker"
import opacity from "react-element-popper/animations/opacity"
import thai from "../../components/Utils/DatePicker/thai"
import thai_th from "../../components/Utils/DatePicker/thai_th"
import useToken from '../../App/useToken';

import './SetCourseTerm.css';

export default function SetCourseTerm({ term, terms, setTerms, addTerm, deleteTerm, setAmount }) {
    const { isAdmin } = useToken();
    const isUserAdmin = isAdmin();
    const termTemps = terms;
    const termIndex = terms.findIndex(e => e.id == term.id);

    const [enabled, setEnabled] = useState(term.enabled);
    const [name, setName] = useState(term.name);
    const [stardTermPeriod, setStardTermPeriod] = useState(term.stardTermPeriod);
    const [endTermPeriod, setEndTermPeriod] = useState(term.endTermPeriod);
    const [amountTerm, setAmountTerm] = useState(term.amount);

    let amountCourse = 0;
    terms.map(term => {
        amountCourse = amountCourse + parseInt(term.amount || 0);
    });
    setAmount(amountCourse);

    const setEnabledValue = (value) => {
        setEnabled(value);
        termTemps[termIndex].enabled = value;
        setTerms(termTemps);
    }

    const setNameValue = (name) => {
        setName(name);
        termTemps[termIndex].name = name;
        setTerms(termTemps);
    }

    const setStardTermPeriodValue = (stardTermPeriod) => {
        setStardTermPeriod(stardTermPeriod);
        termTemps[termIndex].stardTermPeriod = stardTermPeriod;
        setTerms(termTemps);
    }

    const setEndTermPeriodValue = (endTermPeriod) => {
        setEndTermPeriod(endTermPeriod);
        termTemps[termIndex].endTermPeriod = endTermPeriod;
        setTerms(termTemps);
    }

    const setAmountTermValue = (amount) => {
        setAmountTerm(amount);
        termTemps[termIndex].amount = amount;
        setTerms(termTemps);
    }

    return (
        <>
          <Row className='term-container'>
            <Row className='term-text-amount-container'> 
                <Col md={1}>
                    <Form.Group as={Col} onChange={e => setEnabledValue(e.target.checked)}>
                      <Form.Label>เปิด/ปิด</Form.Label>
                      <Form.Check 
                        defaultChecked={enabled}
                        disabled={!isUserAdmin}
                        type="switch"
                      />
                    </Form.Group>
                  </Col>
                <Col md={2}>
                    <span>รุ่นที่: {isUserAdmin && <span className='term-hind'>{term.id}</span>}</span> 
                    <input 
                        required
                        type="strinf"
                        className="form-control"
                        value={term.name || name}
                        disabled={!isUserAdmin}
                        onChange={e => setNameValue(e.target.value)}
                    />
                </Col>
                <Col md={2} className='term-amount-container'> 
                    <span>จำนวนผู้เข้ารับการศึกษา</span> 
                    <input 
                        required
                        type="number"
                        min={1}
                        className="form-control"
                        value={term.amount || amountTerm}
                        disabled={!isUserAdmin}
                        onChange={e => setAmountTermValue(e.target.value)}
                    />
                </Col>
                <Col md={2}>
                    <Form.Group as={Col}>
                        <Form.Label className='label-date'>วันเข้ารับการศึกษา</Form.Label><br />
                        <DatePicker 
                            inputClass='form-control'
                            // calendar={thai} 
                            locale={thai_th} 
                            required
                            format='DD/MMMM/YYYY'
                            animations={[opacity()]} 
                            value={term.stardTermPeriod || stardTermPeriod}
                            disabled={!isUserAdmin}
                            onChange={date => setStardTermPeriodValue(new Date(date.year, date.month.index, date.day))}
                        />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group as={Col}>
                        <Form.Label className='label-date'>วันจบการศึกษา</Form.Label><br />
                        <DatePicker 
                            inputClass='form-control'
                            // calendar={thai} 
                            locale={thai_th} 
                            required
                            format='DD/MMMM/YYYY'
                            animations={[opacity()]} 
                            value={term.endTermPeriod || endTermPeriod}
                            disabled={!isUserAdmin}
                            onChange={date => setEndTermPeriodValue(new Date(date.year, date.month.index, date.day))}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <div>
                {isUserAdmin && <div className='delete-term-btn'>
                    <Button 
                    variant="danger"
                    className='btn-sm'
                    onClick={e => deleteTerm(term.id) } >
                    <FontAwesomeIcon icon={faMinus} />ลบ
                    </Button>
                </div> }
                { isUserAdmin && <div className='add-term-btn'>
                    <Button 
                    variant="success"
                    className='btn-sm'
                    onClick={e => addTerm() } >
                        <FontAwesomeIcon icon={faPlus} />เพิ่ม
                    </Button>
                </div> }
            </div>
            <hr/>
          </Row>
        </>
    );
}